function setCaretAtBeginning(editorDiv: HTMLElement) {
  const range = document.createRange();
  const selection = window.getSelection();
  if (selection === null) {
    return;
  }

  range.selectNodeContents(editorDiv);
  range.collapse(true); // Collapse to the beginning

  selection.removeAllRanges();
  selection.addRange(range);
}

export default setCaretAtBeginning;
